"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _reactRouterDom = require("react-router-dom");
var _cccisdLaravelBoilerplate = require("cccisd-laravel-boilerplate");
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
var _LoginForm = _interopRequireDefault(require("../LoginForm"));
var _AuthRedirect;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppDefs = window.cccisd.appDefs;
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var _default = exports["default"] = (0, _reactRouterDom.withRouter)((_AuthRedirect = /*#__PURE__*/function (_React$Component) {
  function AuthRedirect() {
    _classCallCheck(this, AuthRedirect);
    return _callSuper(this, AuthRedirect, arguments);
  }
  _inherits(AuthRedirect, _React$Component);
  return _createClass(AuthRedirect, [{
    key: "render",
    value: function render() {
      /*
      -if anon
      redirect to login page or render login form
      -if registered
      if url matches a route
          need to check which route is role homepage and send 'em there
      else if no homepage redirect to /
      else (no match)
          render 404
      */
      var content = 'Redirecting...';
      if (!Fortress.auth()) {
        var actionText = 'Log In';
        if ((0, _get2["default"])(AppDefs, 'app.login.labels.title', null)) {
          actionText = (0, _get2["default"])(AppDefs, 'app.login.labels.title');
        } else if ((0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.loginActionText', null)) {
          actionText = (0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.loginActionText');
        }
        content = /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            maxWidth: '400px',
            margin: '0 auto'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, actionText)), /*#__PURE__*/_react["default"].createElement(_LoginForm["default"], {
          defaultRedirectUrl: Boilerplate.url(this.props.location.pathname),
          title: ""
        }));
      }
      if (Fortress.auth()) {
        var nav = (0, _cccisdLaravelAppdefs.findNav)(AppDefs.navs, AppDefs.routes);
        var homepageRoute = Fortress.settings.role === 'questprojectadmin' ? {
          url: '/quest'
        } : (0, _find2["default"])(AppDefs.routes, function (r) {
          return r.handle === nav.homepage;
        });

        // if this is not a pass-through display default 404 page
        if (this.props.isComponentOnly) {
          content = /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.NotFound, null);
        } else if (homepageRoute) {
          content = /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
            to: {
              pathname: homepageRoute.url
            }
          });
        } else {
          content = /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
            to: {
              pathname: '/'
            }
          });
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, content);
    }
  }]);
}(_react["default"].Component), _defineProperty(_AuthRedirect, "propTypes", {
  location: _propTypes["default"].object,
  match: _propTypes["default"].object,
  history: _propTypes["default"].object,
  /**
   * This components also handles showing the 404 page.
   * We pass this prop when we know we want to show the 404 page
   */
  isComponentOnly: _propTypes["default"].bool
}), _AuthRedirect));